// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ZjBx1","center":"Modal_center__8Xrs5","overlay":"Modal_overlay__oENs7"};